import axios from 'axios';
import api from './AxiosInstance';

const url = process.env.REACT_APP_API_URL
// const headersJson = localStorage.getItem('token') !== null ? { Authorization: `Bearer ${(localStorage.getItem('token'))}`, "Content-Type": "application/json" } : {};

const headersJson = (token) => {
    console.log(token, 'token-------')
    return token !== null ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } : {};
}
const headersFormData = (token) => {
    return token !== null ? { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } : {};
}

// ADMIN API INTEGRATION

export const adminSendOTP = (email) => {
    const body = {
        email: email
    }
    return api.post(`/admin/sendOTP`, body);
}
export const adminVerifyOTP = (email, otp) => {
    const body = {
        email: email,
        otp: otp
    }
    return api.post(`/admin/Login-new`, body);
}
export const adminSendVendorOTP = (phoneNumber) => {
    const body = {
        phoneNumber: phoneNumber,
        by_admin: true
    }
    return api.post(`/auth/sendOtp`, body);
}
export const adminVerifyVendorOTP = (phoneNumber, otp) => {
    const body = {
        phoneNumber: phoneNumber,
        otp: otp
    }
    return api.post(`/auth/login`, body);
}

export const adminRegisterVendor = (values) => {
    // const body = {
    //    ...values
    // }
    // return api.post(`/user/registration`, body);
    const formData = new FormData();
    formData.append(`vendor_id`, values.vendor_id);
    formData.append(`account_type`, values.account_type);
    formData.append(`companyName`, values.companyName);
    formData.append(`firstName`, values.firstName);
    formData.append(`lastName`, values.lastName);
    formData.append(`email`, values.email);
    formData.append(`city`, values.city);
    formData.append(`address`, values.address);
    formData.append(`businessRegistration`, values.businessRegistration);
    formData.append(`phoneNumber`, values.phoneNumber);
    formData.append(`aadhaar_number`, values.aadhaar_number);
    formData.append(`by_admin`, true);

    // Object.entries(values.vendor_bank_details).forEach(([key, value]) => {
    //     formData.append(`vendor_bank_details[${key}]`, value);
    // });

    return api.post(`user/registration`, formData, {
        headers: headersFormData(localStorage.getItem('token'))
    });
}

export const adminUpdateBankDetails = (val) => {
    const body = {
        user_id: val.user_id,
        upi_id: val.upi_id,
        vendor_bank_details: {
            branch_name: val.branch_name,
            account_holder_name: val.account_holder_name,
            account_ifsc: val.account_ifsc,
            account_number: val.account_number,
        },
        firstName: val.firstName,
        lastName: val.lastName,
        address: val.address,
        city: val.city,
        companyName: val.companyName,
        businessRegistration: val.businessRegistration,
        email: val.email,
    };

    return api.put(`user/updateBankDetails`, body);
};

export const adminLogin = (email, password) => {
    const body = {
        email: email,
        password: password
    }
    return api.post(`admin/login`, body);
}
export const adminForgotPassword = (email) => {
    const body = {
        email: email
    }
    return api.post(`admin/forgotPassword`, body, { headers: headersJson(localStorage.getItem('token')) });
}

export const adminChangePassword = (oldPassword, newPassword) => {
    const body = {
        old_password: oldPassword,
        new_password: newPassword
    }
    return api.post(`admin/changePassword`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const getUsers = (user_id, status, role, filterType, searchKeyword, limit, page, by_admin) => {
    const params = {
        user_id: user_id,
        role: role,
        status: status,
        searchquery: filterType,
        searchstring: searchKeyword,
        limit: limit,
        page: page,
        by_admin: by_admin
    }
    return api.get(`admin/getUser`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminUpdateUserStatus = (status, id) => {
    const body = {
        user_id: id,
        is_enable: status,
    }
    return api.put(`admin/enableDisableUser`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const getTrips = (tripId, user_id, status, searchKeyword, limit, page) => {
    const params = {
        trip_id: tripId,
        user_id: user_id,
        status: status,
        search: searchKeyword,
        limit: limit,
        page: page
    }
    return api.get(`admin/getCustomerTripReq`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminApproveCabImage = (cabId, docName, isApproved) => {
    const body = {
        cab_id: cabId,
        doc_name: docName,
        is_approved: isApproved
    }
    return api.post(`/admin/approve-reject-cab-docs`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const updateUserStatus = (id, status, text) => {
    const body = {
        user_id: id,
        status: status,
        reasonForRejection: text
    }
    return api.put(`admin/updateStatus`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const getTripList = (status, limit, page, statusTab) => {
    const params = {
        status: status,
        limit: limit,
        page: page,
        is_deleted: statusTab
    }
    return api.get(`admin/getReq`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const deleteTripRequest = (tripId, text) => {
    const body = {
        trip_id: tripId,
        delete_reason: text
    }
    return api.delete(`admin/deleteRequest`, { headers: headersJson(localStorage.getItem('token')), data: body })
}

export const customerQuery = (searchQuery, limit, page, user_id) => {
    const params = {
        user_id: user_id,
        searchQuery: searchQuery,
        limit: limit,
        page: page
    }

    return api.get(`customerSupport/getAllQuery`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const customerQueryReply = (_id, user_id, query_id, text) => {
    const body = {
        _id: _id,
        user_id: user_id,
        query_id: query_id,
        answer: text
    }
    return api.post(`customerSupport/resolveQuery`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAddCarousel = (carousel_array) => {
    console.log(carousel_array)
    const formData = new FormData();
    carousel_array.forEach((image, index) => {
        if (image) {
            formData.append(`index`, index);
            formData.append(`carousel_image`, image);
        }
    });
    // carousel_images.forEach((image, index) => {
    //     if (image) {
    //         formData.append(`carousel_image[]`, image);
    //         formData.append(`index[]`, index);
    //     }
    // });

    return api.post(`slider/saveNew`, formData, {
        headers: headersFormData(localStorage.getItem('token'))
    });
};

export const getCarousel = () => {

    return api.get(`slider/getAll`, { headers: headersJson(localStorage.getItem('token')) })
}
export const deleteCarousel = (id) => {
    console.log(id)
    const params = {
        _id: id
    }

    return api.delete(`slider/delete`, { headers: headersJson(localStorage.getItem('token')), params })
}
export const adminAddYoutubeLink = (link) => {
    const body = {
        video_link: link
    }

    return api.post(`admin/update-video-link`, body,
        { headers: headersJson(localStorage.getItem('token')) }
    );
};

export const getYoutubeVideo = () => {

    return api.get(`admin/get-video-link`, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAddCab = (values) => {
    const body = {
        category: values.category,
        vehicleType: values.vehicleType,
        rate_per_km: values.rate_per_km,
        extra_fare_per_km: values.extra_fare_per_km,
        commission: values.commission,
        waiting_charge: values.waiting_charge
    }
    return api.post(`admin/saveCab`, body, { headers: headersJson(localStorage.getItem('token')) })
}


export const adminGetCab = () => {
    return api.get(`user/getVehicleType`, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminUpdateCab = (id, values) => {
    const params = {
        _id: id
    }
    const body = {
        category: values.category,
        vehicleType: values.vehicleType,
        rate_per_km: values.rate_per_km,
        extra_fare_per_km: values.extra_fare_per_km,
        commission: values.commission,
        waiting_charge: values.waiting_charge
    }
    return api.put(`admin/updateCab`, body, { headers: headersJson(localStorage.getItem('token')), params })
}
export const adminDeleteCab = (id) => {
    const params = {
        _id: id
    }
    return api.delete(`admin/deleteCab`, { headers: headersJson(localStorage.getItem('token')), params })
}

export const sendOTPForDelete = (mobileNumber) => {
    const body = {
        phoneNumber: mobileNumber
    }
    return api.post(`user/sendOTPForDelete`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const verifyOTPForDelete = (mobileNumber, otp) => {
    console.log(mobileNumber, otp)
    const body = {
        phoneNumber: mobileNumber,
        otp: otp
    }
    return api.post(`user/verifyOTPForDelete`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const deleteAccount = (user_id) => {
    console.log(user_id)
    const params = {
        user_id: user_id
    }
    return api.delete(`user/deleteAccount`, { headers: headersJson(localStorage.getItem('token')), params })
}

export const adminGetConfigurations = () => {
    return api.get(`admin/get-configuration`, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAddConfiguration = (autoCancelTime, unavailabilityCharge, cancelationCharge, referrerCount, viewSlider, showAlert, alertMessage, alertMessageSpeed) => {
    console.log(autoCancelTime, unavailabilityCharge, cancelationCharge, referrerCount)
    const body = {
        auto_cancel_timing: autoCancelTime,
        no_show_deduction: unavailabilityCharge,
        after_driver_assignment: cancelationCharge,
        referral_count: referrerCount,
        show_slider: viewSlider,
        show_alert: showAlert,
        alert_message: alertMessage,
        alert_message_speed: alertMessageSpeed,
    }
    return api.post(`admin/update-configuration`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminGetPlans = () => {
    return api.get(`admin/get-plans`, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAddPlan = (values) => {
    const body = {
        name: values.name,
        price: values.price,
        validity: values.validity,
        description: values.description,
        validityType: values.validityType
    }
    return api.post(`admin/add-plan`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminUpdatePlan = (planId, values) => {
    const params = {
        plan_id: planId
    }
    const body = {
        name: values.name,
        price: values.price,
        validity: values.validity,
        description: values.description,
        validityType: values.validityType
    }
    return api.put(`admin/update-plan`, body, { headers: headersJson(localStorage.getItem('token')), params })
}

export const adminDeletePlan = (planId) => {
    const params = {
        plan_id: planId
    }
    return api.delete(`admin/delete-plan`, { headers: headersJson(localStorage.getItem('token')), params })
}
export const UpdatePlanRecommended = (planId) => {
    const body = {
        plan_id: planId
    }
    return api.put(`admin/update-plan-recommended`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAssignPlan = (userId, planId) => {
    const body = {
        user_id: userId,
        plan_id: planId
    }
    return api.put(`admin/assign-plan-to-user`, body, { headers: headersJson(localStorage.getItem('token')) })
}
export const adminGetDashboard = (data, token) => {
    const params = {
        filterType: data?.filterType,
    }
    return api.get(`admin/get-dashboard-data`, { headers: headersJson(localStorage.getItem('token')), params })
}

export const adminGetAllCabs = (phoneNumber, firstName, lastName, fullName, owner_name, rc_number, currentPage, pageSize, cabId) => {
    const params = {
        phoneNumber: phoneNumber,
        firstName: firstName,
        lastName: lastName,
        fullName: fullName,
        owner_name: owner_name,
        rc_number: rc_number,
        cab_id: cabId,
        page: currentPage,
        limit: pageSize
    }
    return api.get(`admin/getVehiclesWithAdditionalDetails`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminAddEditCompanyName = (name, _id) => {
    const body = {
        name: name,
        _id: _id
    }
    return api.post(`admin/addEditCompanyName`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminGetCompanyNames = (_id, search, currentPage, pageSize) => {
    console.log('first', _id, search, currentPage)
    const params = {
        _id: _id,
        search: search,
        page: currentPage,
        limit: pageSize,

    }
    return api.get(`admin/getCompanyNames`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminDeleteCompanyName = (id) => {
    const params = {
        id: id
    }
    return api.delete(`admin/deleteCompanyName`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminAddEditModelName = (data) => {
    console.log("first", data)
    const body = {
        companyname: data?.companyname,
        name: data?.name,
        _id: data?._id
    }
    return api.post(`admin/addEditModelName`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminGetAllModelNames = (companyname_id, modelname_id, search, currentPage, pageSize) => {
    const params = {
        companyname_id: companyname_id,
        modelname_id: modelname_id,
        search: search,
        page: currentPage,
        limit: pageSize,
    }
    return api.get(`admin/getAllModelNames`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminDeleteModelName = (id) => {
    const params = {
        id: id
    }
    return api.delete(`admin/deleteModelName`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const adminAddCompanyAndModel = (companyname, modelname) => {
    const body = {
        companyname: companyname,
        modelname: modelname
    }
    return api.post(`admin/addCompanyAndmodel`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminVerifyCabNumber = (cabNumber) => {
    const body = {
        cab_number: cabNumber
    }
    return api.post(`admin/verify-vehicle-number`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAddVendorCab = (formData) => {
    return api.post(`admin/listCab`, formData, { headers: headersFormData(localStorage.getItem('token')) })
}

export const adminGetDriverDetailsByLicense = (data) => {
    const body = {
        license_number: data.license_number,
        dob: data.dob
    }

    return api.post(`user/get-driver-by-license`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const adminAddDriver = (formData) => {

    return api.post(`admin/addEditDriver`, formData, { headers: headersFormData(localStorage.getItem('token')) })
}

// Bulk SMS Campaign APIs
export const campaignUpload = (formData) => {
    return api.post(`admin/campaign/upload`, formData, { headers: headersFormData(localStorage.getItem('token')) })
}

export const campaignGetAll = () => {
    return api.get(`admin/campaign/list`, { headers: headersJson(localStorage.getItem('token')) })
}

export const campaignGetById = (campaignId) => {
    let params = {
        campaign_id: campaignId
    }
    return api.get(`admin/campaign/detail`, { headers: headersJson(localStorage.getItem('token')), params: params })
}

export const campaignSend = (campaignId) => {
    let body = {
        campaign_id: campaignId
    }
    return api.post(`admin/campaign/send`, body, { headers: headersJson(localStorage.getItem('token')) })
}

export const campaignSendVoice = (campaignId) => {
    const body = { campaign_id: campaignId }
    return api.post(`admin/campaign/send-voice`, body, { headers: headersJson(localStorage.getItem('token')) })
}
export const adminDeleteUser = (userId) => {
    const params = {
        user_id: userId
    }
    return api.delete(`admin/deleteAccount`, { headers: headersJson(localStorage.getItem('token')), params: params })
}
export const downloadUsersExcel = (user_id, status, role, filterType, searchKeyword, limit, page, by_admin) => {
    const body = {
        user_id: user_id,
        role: role,
        status: status,
        searchquery: filterType,
        searchstring: searchKeyword,
        limit: limit,
        page: page,
        by_admin: by_admin
    }
    return api.post(`admin/download-users-excel`, body, { headers: headersJson(localStorage.getItem('token')), responseType: 'blob' })
}

export const adminGetPlanAnalytics = (filters, signal) => {
    const params = {
        filterType: filters?.filterType || 'last_30_days',
        // browser tz as "minutes east of UTC" (IST -> 330); API default is IST
        tz_offset: -new Date().getTimezoneOffset(),
        top_limit: filters?.topLimit || 10,
    }
    if (filters?.filterType === 'custom') {
        params.from = filters?.from;
        params.to = filters?.to;
    }
    if (filters?.granularity) {
        params.granularity = filters.granularity;
    }
    return api.get(`admin/get-plan-analytics`, { headers: headersJson(localStorage.getItem('token')), params, signal })
}
